import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle` 

  body {
    padding: 0;
    margin: 0;

    font-size: 100%; 
    overflow: hidden;
   
  }
  
  p{
    margin: 0;
    padding: 0;
  }

  body, textarea, button, div, h1, h2, h3, h4, h5, h6{
    font-family: Sora;
  }

  button{
    cursor: pointer;

  }

  html {
    font-size: 14px;

    @media screen and (min-width: 1420px){
      font-size: 1rem;
    }
    @media screen and (min-width: 1520px){
      font-size: 1.07rem;
    }
    /* @media screen and (min-width: 1620px){
      font-size: 1.14rem;
    } */
    /* @media screen and (min-width: 1720px){
      font-size: 1.21rem;
    }
    @media screen and (min-width: 1820px){
      font-size: 1.28rem;
    }
    @media screen and (min-width: 1920px) {
      font-size: 1.35rem;

    } */
  }

  .toastify-success {
    --toastify-color-light: linear-gradient(180deg, #585e66 0%, #42464c 100%);
    --toastify-icon-color-success: #55dd99;
    color: #fff;
    font-size: 12px;


    .Toastify__progress-bar {
      background: #55dd99;

      
    }

    .Toastify__close-button {
      color: #55dd99;
}
  }

  .toastify-error {
    --toastify-color-light: linear-gradient(180deg, #585e66 0%, #42464c 100%);
    color: #fff;
    font-size: 12px;
    --toastify-icon-color-error:  #F86464;
    .Toastify__progress-bar {
      background:  #F86464;
    }
    .Toastify__close-button {
      color: #F86464;
}
  }
`;

export default GlobalStyle;
